import { memo, forwardRef } from 'react';
import { StyledButton, ChildrenContainer, StyledSpinner, ButtonIcon, StyledLink, StyledAnchor } from './styles.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { MouseClickFocusRemover } from '../../utils/mouse-click-remover.js';

const Button = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    loading,
    iconPosition,
    iconVerticalAlignment,
    svgIcon,
    svgIconTransform,
    size,
    variant = "primary",
    emptyWhileLoading,
    horizontalAlignment,
    className,
    ...props
  } = _ref;
  return /*#__PURE__*/jsx(StyledButton, {
    "aria-label": children?.toString(),
    ...props,
    size: size,
    variant: variant,
    loading: loading,
    ref: ref,
    className: `otto-button ${className}`,
    children: /*#__PURE__*/jsxs(MouseClickFocusRemover, {
      "aria-hidden": "true",
      children: [/*#__PURE__*/jsx(ChildrenContainer, {
        $horizontalAlignment: horizontalAlignment,
        $emptyWhileLoading: emptyWhileLoading,
        $loading: loading,
        children: children
      }), loading && /*#__PURE__*/jsx(StyledSpinner, {
        buttonSize: size,
        size: size === "large" ? "small" : "xSmall",
        color: variant === "primary" || variant === "destructiveSolid" ? "white" : "grey",
        isCentered: !children || emptyWhileLoading
      }), svgIcon && !loading && /*#__PURE__*/jsx(ButtonIcon, {
        buttonSize: size,
        iconPosition: iconPosition,
        iconVerticalAlignment: iconVerticalAlignment,
        svgIcon: svgIcon,
        transform: svgIconTransform
      })]
    })
  });
}));

/**
 * Please do not use these two combinations:  \
 * `size="large" variant="minor"`  \
 * `size="small" variant="destructive"`
 * ___
 * For more information see https://design.izettle.net/components/buttons/web
 */
const ButtonStyledLink = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref2, forwardedRef) => {
  let {
    children,
    iconPosition,
    svgIcon,
    svgIconTransform,
    size,
    className,
    ...props
  } = _ref2;
  return /*#__PURE__*/jsx(StyledLink, {
    ...props,
    size: size,
    innerRef: forwardedRef,
    className: `otto-button ${className}`,
    children: /*#__PURE__*/jsxs(MouseClickFocusRemover, {
      children: [children, svgIcon && /*#__PURE__*/jsx(ButtonIcon, {
        buttonSize: size,
        iconPosition: iconPosition,
        svgIcon: svgIcon,
        transform: svgIconTransform
      })]
    })
  });
}));

/**
 * Please do not use these two combinations:  \
 * `size="large" variant="minor"`  \
 * `size="small" variant="destructive"`
 * ___
 * For more information see https://design.izettle.net/components/buttons/web
 */
const ButtonStyledAnchor = /*#__PURE__*/memo( /*#__PURE__*/forwardRef((_ref3, ref) => {
  let {
    children,
    iconPosition,
    svgIcon,
    svgIconTransform,
    size,
    className,
    ...props
  } = _ref3;
  return /*#__PURE__*/jsx(StyledAnchor, {
    ...props,
    size: size,
    ref: ref,
    className: `otto-button ${className}`,
    children: /*#__PURE__*/jsxs(MouseClickFocusRemover, {
      children: [children, svgIcon && /*#__PURE__*/jsx(ButtonIcon, {
        buttonSize: size,
        iconPosition: iconPosition,
        svgIcon: svgIcon,
        transform: svgIconTransform
      })]
    })
  });
}));

export { Button, ButtonStyledAnchor, ButtonStyledLink };
//# sourceMappingURL=index.js.map
